import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetCompanyListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    selectedIsCustomActives: CustomMultiSelectModel[]
    selectedFirmTypes: CustomMultiSelectModel[]
    selectedIsB2cs: CustomMultiSelectModel[]
    columnChooser: ColumnChooserModel[] | undefined
    selectedMeetingCompanyTypes: CustomMultiSelectModel[]
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetCompanyListPagingAndFilterRequest: GetCompanyListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    selectedIsCustomActives: [],
    selectedFirmTypes: [],
    selectedIsB2cs: [],
    columnChooser: undefined,
    // Firma durumu varsayılanı (Çalışılan Müşteri) artık kolon filtresi (CompanyList açılışında kurulur).
    selectedMeetingCompanyTypes: [],
    columnFilters: []
}